import { useState } from 'react'

import api from 'utils/api'

const useUploadImageToS3 = () => {
  const [isLoading, setIsLoading] = useState(false)

  const uploadImageToS3 = async (itemImageFormData) => {
    setIsLoading(true)
    try {
      const response = await api.uploadImageToS3(itemImageFormData)
      return response
    } catch (error) {
      console.error(error)
    } finally {
      setIsLoading(false)
    }
  }

  return { uploadImageToS3, isLoading }
}

export default useUploadImageToS3
